
import styled from "styled-components"
import InputText from "../shared/input/new/InputText"
import { useEffect, useState } from "react"
import InputTextarea from "../shared/input/new/InputTextarea"
import InputSelect from "../shared/input/new/InputSelect"
import { menuOptions, sendOptions, subMenuOptions } from '../../utils/bildirimOptions'
import Btn from "../shared/button/Btn"
import { clearScheduledData, getPhoneNumberForNotification, sendNotificationSpesific, setMobileNotification, setNotificationMenu, setNotificationSendType, setNotificationSubMenu, setNotificationText, setNotificationTitle, setSelectedPhoneNumbers } from "../../features/admin4/admin4Slice"
import { useDispatch, useSelector } from "react-redux"
import InputSelectForNotification from "../shared/input/new/InputSelectForNotification"
import { IoCloseCircleOutline } from "react-icons/io5";
import SmallSpinner from "../shared/spinners/SmallSpinner"
import { MdOutlineCheck } from "react-icons/md";
import RegularMonthSelectContainer from "./RegularMonthSelectContainer"
import RegularWeekSelectContainer from "./RegularWeekSelectContainer"
import TargetDateNotificationContainer from "./TargetDateNotificationContainer"

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;

    .main-content-container{
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        gap: 50px;

        .input-side{
            display: flex;
            flex-direction: column;
            gap: 20px;
        }

        .check-container{
            display: flex;
            align-items: center;
            gap: 10px;
            cursor: pointer;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);

            .checkbox{
                width: 20px;
                height: 20px;
                border: 1px solid;
                border-color: ${({ theme }) => theme.mainBorderColor};
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

    .list-side{
        display: flex;
        flex-direction: column;
        gap: 20px;

        .phone-number-list{
            display: flex;
            flex-direction: column;
            gap: 20px;
            max-height: 285px;
            overflow: auto;
            border: 1px solid ${({theme}) => theme.mainBorderColor};
            border-radius: 10px;
            padding: 10px;

            &::-webkit-scrollbar {
                width: 0;
                width: 6px;
            }
            &::-webkit-scrollbar-thumb {
                background-color: ${({theme})=> theme.scrollThumbColor};
                border-radius: 10px;
            }
            &::-webkit-scrollbar-track {
                background-color: transparent;
            }
            
            .phone-number-item{
                padding: 8px;
                border: 1px solid var(--color-main);
                border-radius: 10px;
                color: var(--color-main);
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
                display: flex;
                align-items: center;
                gap: 5px;
                cursor: pointer;
                width: 100%;
                

                &:hover{
                    background-color: rgba(232, 86, 70, .08);
                }

                .delete-icon{
                    font-size: 1.2rem;
                }

            }
        }
    }
    }

    .seperator{
        width: 100%;
        height: 1px;
        background-color: ${({theme}) => theme.mainBorderColor};
    }

    .extra-content-container{
        display: flex;
        margin: 20px 0;
        gap: 50px;

        .select-side{

        }

        .select-result-side{
            display: flex;
            flex-direction: column;
            margin-bottom: 20px;

    
        }
    }
`


const SendNotificationSpecific = () => {

    const dispatch = useDispatch()

    const [currentPhoneNumber, setCurrentPhoneNumber] = useState("")

    const {
        notificationTitle,

        notificationText,
    
        notificationMenu,
    
        notificationSubMenu,
    
        mobileNotification,

        isLoadingSendNotificationSpecific,

        phoneNumbersForNotification,

        selectedPhoneNumbers,

        notificationSendType

    } = useSelector(state => state.admin4)

    useEffect(() => {
        dispatch(clearScheduledData())
    },[notificationSendType.id])

    const handleCheck = () => {
        dispatch(setMobileNotification(!mobileNotification))
    }

    useEffect(()=> {
        if(currentPhoneNumber?.length >= 4){
            dispatch(getPhoneNumberForNotification(currentPhoneNumber))
        }
    },[currentPhoneNumber?.length])


    const handleClickNow = () => {
        if(!notificationTitle || !notificationText || !notificationMenu.value || selectedPhoneNumbers.length < 1){

        }
        else{
            const dataa = {message:notificationText, tittle:notificationTitle, screenName:notificationSubMenu.value, routeName:notificationMenu.value, phoneNumbers: selectedPhoneNumbers.map(item => item.phoneNumber), notificationAdded: mobileNotification }
            dispatch(sendNotificationSpesific(dataa))
        }
    }


  return (
    <Container>
        <div className="main-content-container">
            <div className="input-side">
                <InputText data={notificationTitle} setData={(e) => dispatch(setNotificationTitle(e.target.value))} labelText="Bildirim Başlığı" inputWidth={"350px"} name={"title"}/>
                <InputTextarea data={notificationText} setData={(e) => dispatch(setNotificationText(e.target.value))} labelText={"Bildirim Metni"}  inputWidth={"350px"} name={"content"}/>
                <InputSelect data={notificationMenu?.text} setData={(item) =>  dispatch(setNotificationMenu({item, pastNotificationMenu: notificationMenu}))} initialOptions={menuOptions} labelText={"Menü"} inputWidth={"350px"} name={"menu"}/>
                <InputSelect data={notificationSubMenu?.text} setData={(item) => dispatch(setNotificationSubMenu(item))} initialOptions={subMenuOptions.filter(item => item?.mainMenu === notificationMenu?.value)} labelText={"Alt Menü"} inputWidth={"350px"} name={"subMenu"}/>
                <div onClick={handleCheck} className="check-container">
                    <div className="checkbox">
                        {
                            mobileNotification && <MdOutlineCheck />
                        }
                    </div>
                    <p>Mobil uygulamadan bildirim gönderilsin.</p>
            </div>
            </div>
            <div className="list-side">
                <InputSelectForNotification phoneNumberList={selectedPhoneNumbers} setPhoneNumberList={(list) => dispatch(setSelectedPhoneNumbers(list))} data={currentPhoneNumber} setData={setCurrentPhoneNumber} initialOptions={phoneNumbersForNotification} labelText={"Telefon Numarası"} name={"phoneNumbersForNotifications"} inputWidth={"350px"} />
                {
                    selectedPhoneNumbers.length > 0 &&
                    <div className="phone-number-list">
                        {
                            selectedPhoneNumbers.map((item) => (
                                <div className="phone-number-item" onClick={() => dispatch(setSelectedPhoneNumbers(selectedPhoneNumbers.filter(innerItem => innerItem.phoneNumber !== item.phoneNumber )))}>
                                    <IoCloseCircleOutline className="delete-icon"/>
                                    <div className="phone-number">{item.phoneNumber} - {item.username}</div>
                                </div>
                            ))
                        }
                    </div>
                }
            </div>
        </div>
        <div className="seperator"/>
        <div className="extra-content-container">
            <div className="select-side">
                <InputSelect data={notificationSendType?.text} setData={(item) => {dispatch(setNotificationSendType(item))}} initialOptions={sendOptions} labelText={"Gönderim Tipi Seçiniz"} inputWidth={"350px"} name={"sendOptions"}/>
            </div>
            <div className="select-result-side">

                {
                    notificationSendType.id === 0 &&
                    <RegularMonthSelectContainer isAll={false}/>
                }

                {
                    notificationSendType.id === 1 &&
                    <RegularWeekSelectContainer isAll={false}/>
                }

                {
                    notificationSendType.id === 2 &&
                    <TargetDateNotificationContainer isAll={false}/>
                }

                {
                    notificationSendType.id === 3 &&
                    <Btn handleClick={handleClickNow} bgColor="#E85546" color="#fff" width={"350px"}>{isLoadingSendNotificationSpecific ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Gönder"}</Btn>
                }
            </div>
        </div>
    </Container>
  )
}

export default SendNotificationSpecific